<template>
    <div>
        <div class="row card-body">
            <div class="col-md-12" style="padding: 0px 10px 0px 0px;">
                <label class="label_required">{{ $t('res_Label_DeliveryDate') }} <span style="color: red">*</span></label>
                <v-menu content-class="p-0" v-model="delivery_date_menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="dueDate" :label="$t('res_Label_SelectDate')" v-bind="attrs" v-on="on" solo append-icon="mdi-calendar" :tabindex="-1" >
                            <template v-slot:append>
                                <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                            </template>
                        </v-text-field>
                    </template>
                    <v-date-picker v-model="dueDate" @input="delivery_date_menu = false" :min="nowDate"></v-date-picker>
                </v-menu>
            </div>
            <div class="col-md-12 pt-3" style="padding: 0px 10px 0px 0px;">
                <label>{{ $t('res_Label_Courier') }} <span style="color: red">*</span></label>
                <multi-select class="light-bg add-arrow" v-model="courier" label="name" :placeholder="$t('res_Label_Select')" track-by="id"
                            open-direction="bottom" :options="courier_items" :searchable="true" :internal-search="false"
                            :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                            :show-no-results="false" :hide-selected="false" :multiple="false" @search-change="getCourierServiceNames" ref="multiselect2">
                </multi-select>
            </div>
             <div class="col-md-12 pt-3" style="padding: 0px 10px 0px 0px;">
                <label>{{ $t("res_Label_OtherAttachments") }}</label>
                <v-textarea v-model="otherAttachments" label="" class="light-bg" :placeholder="$t('res_Label_defaultTextValue')"></v-textarea>
            </div>
            <div class="col-md-12 pt-3" style="padding: 0px 10px 0px 0px;">
                <v-checkbox v-model="seperatePage" :label="$t('res_Label_SeparatePagesPerRecipient')"></v-checkbox>
            </div>
            <div class="col-md-12 pt-3" style="padding: 0px 10px 0px 0px;">
                <div>
                    <v-data-table disable-sort :headers="headers" :items-per-page="10" :items="recipeints" :loading="loading" loading-text="loading..."
                            hide-default-footer>
                        <template v-slot:item="row">
                            <tr>
                                <td style="display: none">{{ row.item.structureId }}</td>
                                <td>{{ row.item.recipientName }}</td>
                                <td>{{ row.item.code }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </div>
            </div>
            
        </div> 
        <div>
            <v-card-actions class="gap-2 sticky-actions">
                <v-spacer></v-spacer>
                <v-btn class="primary" style="min-width: 100px !important;" @click="openCourierService">{{ $t('res_ButtonText_AddCourier') }}</v-btn>
                <v-btn class="primary" style="min-width: 100px !important;" @click="createDeliveyNote">{{ $t('res_ButtonText_Generate') }}</v-btn>
                <v-btn class="light-blue" style="min-width: 100px !important;" @click="closeDialog">{{ $t('res_ButtonText_Cancel') }}</v-btn>
            </v-card-actions>
        </div>

        <v-dialog v-model="addCourierServiceDialog" width="650" height="">
            <v-card class="py-2">
                <v-card-title>{{ $t('res_Label_CourierService') }}</v-card-title>
                <v-card-text class="mt-4">
                    <label class="label_required">{{ $t('res_Label_CourierServiceName') }} *</label>
                    <v-text-field v-model="courierServiceName" label="" class="light-bg p-2 mt-2"></v-text-field>
                </v-card-text>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="primary" style="min-width: 100px !important;" @click="addCourierService">{{ $t('res_ButtonText_Save') }}</v-btn>
                    <v-btn class="light-blue" style="min-width: 100px !important;" @click="closeCourierServiceDialog">{{ $t('res_ButtonText_Cancel') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="archiveDialog" content-class="small-dialog" width="650" height="">
            <v-card>
                <v-card-title class="text-h5 blue lighten-2">{{ $t('res_Msgs_CompleteCorrespondence') }}</v-card-title>
                <div class="row card-body p-4">
                    <label class="label_required">{{ $t('res_Msgs_EnterNotes') }} <span> *</span></label>
                    <v-text-field v-model="archiveNotes" label="" solo></v-text-field>
                </div>
                <div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn class="primary" style="min-width: 100px !important;" @click="archiveDeliveryNote">{{ $t('res_ButtonText_Save') }}</v-btn>
                        <v-btn class="light-blue" style="min-width: 100px !important;" @click="archiveDialog = false;">{{ $t('res_ButtonText_Close') }}</v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showDeliveryNoteDialog" content-class="dialog with-fixed-actions bg-white justify-content-center" fullscreen scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title>
                        {{ $t("res_Label_DeliveryNote") }}
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-btn class="dgs-new-button-icon" icon @click="exportToPDF" v-bind="attrs" v-on="on" v-tooltip="$t('res_Label_PrintOptions')">
                            <v-icon class="primary-hover">mdi-printer</v-icon>
                        </v-btn>
                        <v-icon @click="showDeliveryNoteDialog = false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
				<div class="p-2 scrollable-container flex-1">
                    <v-row class="h-100">
                        <div id="deliveryNotesBody" class="col-lg-8 px-4 pb-0 height-lg-auto" style="width: 80%;">
                            <div style="overflow: scroll" class="p-0 scrollable-container choose-template">
                                <div v-if="empty_viewer" class="empty-viewer">
                                    <img src="/assets/images/icons/template.svg" /><h2>{{heading}}</h2>
                                </div>
                                <div v-if="viewer" class="viewer_template" style="direction: ltr;height:100%">
                                   <!-- <vue-pdf-embed :source="templateSource" />    -->
				                   <iframe :src="_viewerFrameSrc" style="width: 100%; height: calc(100%)"></iframe>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 pb-0 height-lg-auto">
                            <v-data-table 
                                disable-sort :headers="deliveryNoteHeaders" :items-per-page="100" :items="deliveryNoteData" :loading="loading" loading-text="loading..."
                                    hide-default-footer>
                                <template v-slot:item="row">
                                    <tr>
                                        <td>{{ row.item.recipientName }}</td>
                                        <td>{{ row.item.courierName }}</td>
                                        <td>{{ (row.item.isDelivered == true ? $t('res_ButtonText_Yes') : $t('res_ButtonText_No'))}}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </div>
                    </v-row>
                </div>
				<div class="dialog-footer sticky-footer top-shadow p-3 d-flex align-items-center justify-content-end gap-3 position-relative">
                <!-- <v-card-actions class="gap-2 sticky-actions"> -->
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" style="min-width: 100px !important;" @click= closeDeliveryNoteDialog>{{ $t('res_ButtonText_Cancel') }}</v-btn>
                <!-- </v-card-actions> -->
                </div>
            </v-card>
        </v-dialog>
        <input type="file" style="display:none" accept=".pdf" @change="onFileChanged" ref="uploader"/>
    </div>
</template>

<script>
    import { McWysiwyg } from '@mycure/vue-wysiwyg'
    import constants from "@/assets/js/constants.js"
    import axios from "axios";
    import MultiSelect from 'vue-multiselect'
    import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed.js'
    import * as utils from '@/assets/js/common.js'

    export default {
        name: 'DeliveryNoteConfiguration',
        components: { McWysiwyg, MultiSelect, VuePdfEmbed },
        data: function () {
            return {
                _viewerFrameSrc: '',
                utils: utils,
                count: 1,
                scanedDeliveryNote: {},
                deliveryNoteId: 0,
                storageIds: [],
                empty_viewer: true,
                archiveDialog: false,
                viewer: false,
                heading: this.$t('res_GridHeaders_NoTemplateAvailable'),
                loading: false,
                showDeliveryNoteDialog: false,
                addCourierServiceDialog: false,
                delivery_date_menu: false,
                seperatePage: false,
                dueDate: new Date().toISOString().slice(0,10),
                courierServiceName: '',
                courier: '',
                archiveNotes: '',
                courier_items: [],
                recipeints: [],
                deliveryNoteData: [],
                loading: false,
                nowDate: new Date().toISOString().slice(0,10),
                document:{},
                formData:"",
                otherAttachments:"",
                headers: [
                    { text: this.$t("res_GridHeaders_StructureId"), value: 'structureId', align: '' }, //this.$t("res_GridHeaders_DueDate")
                    { text: this.$t("res_GridHeaders_ReceipientName"), value: 'recipientName' },
                    { text: this.$t("res_GridHeaders_Code"), value: 'code' },
                ],
                deliveryNoteHeaders: [
                    { text: this.$t("res_GridHeaders_ReceipientName"), value: 'recipientName' },
                    { text: this.$t("res_Label_Courier"), value: 'courierName' },
                    { text: this.$t("res_GridHeaders_IsDeliverd"), value: 'isDelivered' },
                ]
            };
        },
        props: {
            documentId: { type: [String, Number], default: '0' },
            referenceNumber: {type: String, default: ""},
            deliveryNoteDialog: { type: Boolean, default: false },
        },
        mounted ()
        {
            this.initForm();
            this.getDocumentDataById();
        },
        methods: 
        {
            exportToPDF() {
                this.printPreview(this.templateSource.replace('data:application/pdf;base64,',''))
            },
            printPreview (data, type = 'application/pdf')  {
                let blob = null;
                blob = this.b64toBlob(data, type);
                const blobURL = URL.createObjectURL(blob);
                const theWindow = window.open(blobURL);
                const theDoc = theWindow.document;
                const theScript = document.createElement('script');
                function injectThis() {
                    window.print();
                }
                theScript.innerHTML = `window.onload = ${injectThis.toString()};`;
                theDoc.body.appendChild(theScript);
            },

            b64toBlob  (content, contentType)  {
                contentType = contentType || '';
                const sliceSize = 512;
                // method which converts base64 to binary
                const byteCharacters = window.atob(content); 

                const byteArrays = [];
                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    const slice = byteCharacters.slice(offset, offset + sliceSize);
                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }
                const blob = new Blob(byteArrays, {
                    type: contentType
                }); // statement which creates the blob
                return blob;
            },

            getDocumentDataById()
            {
                axios.get(constants.baseApiUrl + 'Document/GetDocumentDataById?documentId=' + this.documentId)
                    .then((res) => 
                    {
                        if (res.data != null)
                        {
                            if(res.data.length>0){
                                this.document = {};
                                this.document = res.data[0];
                                console.log('document data = ',JSON.parse(this.document.formData).otherAttachments)
                                this.otherAttachments = JSON.parse(this.document.formData).otherAttachments
                                this.formData = JSON.parse(this.document.formData)
                            }
                            
                        }
                    })
                    .catch((err) => { console.log(err); window.hideLoading(); })
            },
            initForm()
            {
                this.getCourierServiceNames();
                this.getRecipients();
            },
            getRecipients()
            {
                axios.get(constants.baseApiUrl + 'DeliveryNote/GetCourierServiceRecipients?documentId=' + this.documentId)
                    .then((res) => 
                    {
                        if (res.data != null)
                        {
                            this.recipeints = [];
                            this.recipeints = res.data;
                        }
                    })
                    .catch((err) => { console.log(err); window.hideLoading(); })
            },
            getCourierServiceNames(query)
            {
                if(query == undefined)
                    query = "";
                
                axios.get(constants.baseApiUrl + 'DeliveryNote/GetCourierServiceNames?name=' + query)
                    .then((res) => 
                    {
                        if (res.data != null)
                        {
                            this.courier_items = [];
                            this.courier_items = res.data;
                        }
                    })
                    .catch((err) => { console.log(err); window.hideLoading(); })
            },
            closeDeliveryNoteDialog()
            {
                this.showDeliveryNoteDialog = false;
                this.clearData();
            },
            closeDialog()
            {
                window.hideLoading();
                this.$emit('closeDeliveryNote');
            },
            closeCourierServiceDialog()
            {
                this.courierServiceName = '',
                this.addCourierServiceDialog = false 
            },
            clearData()
            {
                this.courier = ''
                this.dueDate = new Date().toISOString().slice(0,10)
                this.otherAttachments = ''
                this.seperatePage = false
            },
            openCourierService()
            {
               this.clearData();
               this.addCourierServiceDialog = true;
            },
            addCourierService()
            {
                this.courierServiceName = this.courierServiceName.trim();
                if(this.courierServiceName == "")
                {
                    window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning');
                    return;
                }
                axios.post(constants.baseApiUrl + 'DeliveryNote/AddCourierServiceName?name=' + this.courierServiceName, )
                    .then((res) => 
                    {
                        if (res.data != null && res.data != 0)
                        {
                           window.showAlert(this.$t('res_Msgs_CourierAdded'), 'success');
                           this.closeCourierServiceDialog();
                           this.getCourierServiceNames();
                        }
                        else
                            window.showAlert(this.$t('res_Msgs_CourierAlreadyExists'), 'warning');
                    })
                    .catch((err) => { console.log(err); window.hideLoading(); })
            },
            getDeliveryNoteData()
            {
                axios.get(constants.baseApiUrl + 'DeliveryNote/GetDeliveryNoteStatusTable?documentId=' + this.documentId, )
                    .then((res) => 
                    {
                        if (res.data != null)
                        {
                            this.deliveryNoteData = res.data;
                            this.showDeliveryNoteDialog = true;
                            this.closeDialog();
                        }
                    })
                    .catch((err) => { console.log(err); window.hideLoading(); })
            },
            createDeliveyNote()
            {
                window.showLoading();
                if (this.seperatePage)
                {
                    if (this.dueDate != "" && this.courier != "")
                    {
                        var requestBody = {
                            count: this.count++,
                            seperatePages: this.seperatePage,
                            referenceNumber: this.referenceNumber,
                            createdDate: this.dueDate,
                            courierId: this.courier.id,
                            status: 2,
                            isDelivered: false,
                            documentId: this.documentId,
                            recipientData :  this.recipeints,
                            otherAttachments : this.otherAttachments
                        }
                        axios.post(constants.baseApiUrl + 'DeliveryNote/CreateSeperateDeliveryNotes', requestBody)
                            .then((res) => 
                            { 
                                if (res.data != null)
                                {
                                    this._viewerFrameSrc =
                                        "/resources/viewer/viewer.html?fileName=" +
                                        res.data.templateUrl +
                                        "&lang=" +
                                        this.$i18n.locale +
                                        "&defaultScale=page-width&pageMode=view" +
                                        "&id=-1&r=" +
                                         new Date().getTime();
                                    this.empty_viewer = false
                                    this.viewer = true;
                                    this.templateSource = 'data:application/pdf;base64,' + res.data.bytes   
                                    this.addDeliveryNote(res.data.bytes);
                                    this.otherAttachments = ""; 
                                }
                            })
                            .catch((err) => console.log(err))
                            .finally(()=> window.hideLoading())
                    }
                    else
                    {
                        window.hideLoading()
                        window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning')
                    }
                }
                else
                {
                    if (this.dueDate != "" && this.courier != "")
                    {
                        var requestBody = {
                            count: this.count++,
                            seperatePages: this.seperatePage,
                            referenceNumber: this.referenceNumber,
                            createdDate: this.dueDate,
                            courierId: this.courier.id,
                            status: 2,
                            isDelivered: false,
                            documentId: this.documentId,
                            recipientData :  this.recipeints,
                            otherAttachments : this.otherAttachments
                        }

                        axios.post(constants.baseApiUrl + 'DeliveryNote/CreateMergedDeliveryNote', requestBody)
                            .then((res) => 
                            {
                                if (res.data != null)
                                { 
                                    this._viewerFrameSrc =
                                        "/resources/viewer/viewer.html?fileName=" +
                                        res.data.templateUrl +
                                        "&lang=" +
                                        this.$i18n.locale +
                                        "&defaultScale=page-width&pageMode=view" +
                                        "&id=-1&r=" +
                                        new Date().getTime();
                                    this.loading = false;
                                    this.empty_viewer = false
                                    this.viewer = true;  
                                    this.templateSource = 'data:application/pdf;base64,' + res.data.bytes   
                                    this.addDeliveryNote(res.data.bytes);
                                    this.otherAttachments = "";
                                }
                            })
                            .catch((err) => console.log(err))
                            .finally(()=> window.hideLoading())
                    }
                    else
                    {
                        window.hideLoading();
                        window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning')
                    }
                }

            },
            addDeliveryNote(byteDataArray)
            {
                var requestBody = {
                    count: this.count++,
                    createdDate: this.dueDate,
                    courierId: this.courier.id,
                    status: 2,
                    isDelivered: false,
                    documentId: this.documentId,
                    PdfDocArray: byteDataArray,
                    referenceNumber: this.referenceNumber
                }
                axios.post(constants.baseApiUrl + 'DeliveryNote/AddDeliveryNote', requestBody)
                    .then((res) => 
                    {
                        if (res.data != null)
                        {
                            window.showAlert(this.$t('res_Msgs_DeliveryNodeAdded'), 'success');
                            this.deliveryNoteId = res.data.item1;
                            this.storageIds.push(res.data.item2);
                            this.getDeliveryNoteData();
                        }
                    })
                    .catch((err) => { console.log(err); window.hideLoading(); })
            },
            onFileChanged(e) 
            {
                if(this.$refs.uploader.files[0].size <= 0)
                {
                    window.showAlert(this.$t('res_Msgs_EmptyFile'), "warning");
                }
                else
                {
                    this.uploadFile(this.$refs.uploader.files[0]);
                }
            },
            uploadFile(selectedFile)
            {
                if(selectedFile)
                {
                    this.readFile(selectedFile, (fileBytes) => 
                    {
                        var body = {
                            documentId: this.documentId,
                            updateFileData: fileBytes,
                            count: this.count,
                            storageAttachmentId: this.storageIds[0]
                        }
                        axios.post(constants.baseApiUrl + "DeliveryNote/UpdateDeliveryNoteStatus", body)
                        .then((res) => 
                        {
                            if (res.data != null)
                            {
                                this.getDeliveryNoteData();
                                window.showAlert(this.$t('res_Msgs_ScannedFileUploaded'), "sucess");
                            }
                        })
                        .catch((err) => { console.log(err); window.hideLoading(); })
                    });
                }
            },
            async readFile(file, successHandler) 
            {
                var reader = new FileReader();
                    var fileByteArray = [];
                    reader.readAsArrayBuffer(file);
                    reader.onloadend = function (evt) {
                        if (evt.target.readyState == FileReader.DONE) 
                        {
                            var arrayBuffer = evt.target.result,
                                array = new Uint8Array(arrayBuffer);
                            for (var i = 0; i < array.length; i++) 
                            {
                                fileByteArray.push(array[i]);
                            }
                            
                            successHandler(fileByteArray);
                        }
                    }
            },
            scanDeliveryNote()
            {
                this.$refs.uploader.click();
            },
            openArchiveDialog()
            {
                this.archiveDialog = true;
            },
            archiveDeliveryNote()
            {
                if(this.archiveNotes != "")
                {
                    axios.post(constants.baseApiUrl + 'DeliveryNote/ArchiveDeliveryNote?deliveryNoteId=' + this.deliveryNoteId)
                    .then((res) => 
                    {
                        if (res.data != null)
                        {
                           window.showAlert(this.$t('res_Msgs_DeliveryNoteArchived'), 'sucess');
                           this.archiveDialog = false;
                           this.closeDeliveryNoteDialog();
                        }
                    })
                    .catch((err) => { console.log(err); window.hideLoading(); })
                }
                else
                {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning');
                }
            },
            convertBase64ToBlob(base64) {
                const byteCharacters = atob(base64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                return new Blob([byteArray], { type: 'application/pdf' });
            },
        },
        watch: 
        {
            deliveryNoteDialog(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal == true)
                        this.initForm()
                    else
                        this.clearData()
                }
            }
        },
    }
</script>

<style>
    .v-icon.v-icon.v-icon--link {
        cursor: pointer;
        outline: none;
        left: 0% !important;
        position: relative !important;
    }
</style>
